import { FC, useState } from 'react'

import arrowLeft from '@/assets/icons/arrow-left.svg'
import arrowRight from '@/assets/icons/arrow-right.svg'
import calendar from '@/assets/icons/calendar.svg'
import {
  Icon,
  WeekSwitcherButton,
  WeekSwitcherDateIconWrapper,
  WeekSwitcherDateLabel,
  WeekSwitcherDateWrapper,
  WeekSwitcherWrapper,
} from '@/components/DataWidget/styles'
import { dateTranslation } from '@/i18n/dateTranslation'

import { WeekSwitcherProps } from '../types'

export const WeekSwitcher: FC<WeekSwitcherProps> = ({
  week,
  onPrevWeek,
  onNextWeek,
  nextDisabled,
  prevDisabled,
}) => {
  const [defaultFocusChild, setDefaultFocusChild] = useState(0)

  const updateFocusIdChild = (e: MoveEvent) => {
    setDefaultFocusChild(e.nextChildIndex)
  }

  const dateLabel = `${dateTranslation(
    week.start,
    'MMM, dd',
  )} — ${dateTranslation(week.end, 'MMM, dd')}`

  const PrevButtonNode = (
    <WeekSwitcherButton onSelected={onPrevWeek} $disabled={prevDisabled}>
      <Icon src={arrowLeft} />
    </WeekSwitcherButton>
  )

  const NextButtonNode = (
    <WeekSwitcherButton onSelected={onNextWeek} $disabled={nextDisabled}>
      <Icon src={arrowRight} />
    </WeekSwitcherButton>
  )

  const WeekNode = (
    <WeekSwitcherDateWrapper>
      <WeekSwitcherDateIconWrapper>
        <Icon src={calendar} />
      </WeekSwitcherDateIconWrapper>
      <WeekSwitcherDateLabel>{dateLabel}</WeekSwitcherDateLabel>
    </WeekSwitcherDateWrapper>
  )

  return (
    <WeekSwitcherWrapper
      defaultFocusChild={defaultFocusChild}
      onMove={updateFocusIdChild}
    >
      {PrevButtonNode}
      {WeekNode}
      {NextButtonNode}
    </WeekSwitcherWrapper>
  )
}
